<!-- Floating button -->
<div class="chat-fab" (click)="chat.toggleChat()"
     [class.open]="chat.isOpen()">
  <span *ngIf="!chat.isOpen()">💬</span>
  <span *ngIf="chat.isOpen()">✕</span>
</div>

<!-- Chat popup -->
<div class="chat-popup" [class.visible]="chat.isOpen()">

  <!-- Header -->
  <div class="chat-header">
    <div class="header-left">
      <span class="dot online"></span>
      <span>Company AI Assistant</span>
    </div>
    <div class="header-right">
      <button (click)="chat.clearChat()" title="Clear chat">🗑</button>
      <button (click)="chat.closeChat()">✕</button>
    </div>
  </div>

  <!-- Messages -->
  <div class="chat-messages">

    <!-- Empty state with suggestions -->
    <div class="empty" *ngIf="chat.modelMessages().length === 0">
      <p>🤖 Hi! I'm your AI Assistant.</p>
      <p class="hint">Ask me about your assets, HR details, and more.</p>
      <div class="suggestions">
        <button (click)="sendSuggestion('Show my assets')">📦 My Assets</button>
        <button (click)="sendSuggestion('Show my details')">👤 My Details</button>
        <button (click)="sendSuggestion('My leave balance')">📅 Leave Balance</button>
        <button (click)="sendSuggestion('Raise a support ticket')">🎫 Support Ticket</button>
      </div>
    </div>

    <!-- Messages list -->
    <ng-container *ngFor="let msg of chat.modelMessages(); trackBy: trackById">

      <!-- Bot label -->
      <div class="bot-label"
           *ngIf="msg.role === 'assistant' && msg.bot && !msg.isStreaming">
        {{ getBotLabel(msg.bot) }}
      </div>

      <!-- Message bubble -->
      <div class="msg-bubble" [class.user]="msg.role === 'user'"
                              [class.assistant]="msg.role === 'assistant'">
        <span *ngIf="!msg.isStreaming">{{ msg.content }}</span>
        <span *ngIf="msg.isStreaming" class="typing">
          <span></span><span></span><span></span>
        </span>
      </div>

    </ng-container>

    <div #messagesEnd></div>
  </div>

  <!-- Error -->
  <div class="error-bar" *ngIf="chat.errorMsg()">
    ⚠ {{ chat.errorMsg() }}
  </div>

  <!-- Input -->
  <div class="chat-input">
    <textarea #inputEl
              [(ngModel)]="inputText"
              (keydown)="onKeyDown($event)"
              (input)="autoGrow(inputEl)"
              placeholder="Ask about assets, HR, leave..."
              rows="1"
              [disabled]="chat.isModelStreaming()">
    </textarea>
    <button (click)="send()"
            [disabled]="chat.isModelStreaming() || !inputText.trim()">
      <span *ngIf="!chat.isModelStreaming()">▶</span>
      <span *ngIf="chat.isModelStreaming()" class="spinner"></span>
    </button>
  </div>

</div>